export const projectConstants = {
  CREATE_PROJECT: 'CREATE_PROJECT',
  RETRIEVE_PROJECTS: 'RETRIEVE_PROJECTS',
  UPDATE_PROJECT: 'UPDATE_PROJECT',
  DELETE_PROJECT: 'DELETE_PROJECT',
  DELETE_ALL_PROJECT: 'DELETE_ALL_PROJECT',
}
